import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQAccordion = ({ faqs = [] }) => {
  const [activeItem, setActiveItem] = useState(0);

  return (
    <div className="home-reveal rounded-3xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <div className="space-y-3">
        {faqs.map((faq, index) => {
          const isOpen = activeItem === index;

          return (
            <article key={faq.question} className="rounded-xl border border-slate-100 bg-slate-50/70">
              <button
                type="button"
                onClick={() => setActiveItem((prev) => (prev === index ? -1 : index))}
                className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left sm:px-5 sm:py-4"
                aria-expanded={isOpen}
              >
                <span className="text-sm font-semibold text-slate-900 sm:text-base">{faq.question}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 text-slate-500 transition-transform duration-200 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {isOpen ? (
                <div className="px-4 pb-4 sm:px-5">
                  <p className="text-sm leading-relaxed text-slate-600">{faq.answer}</p>
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default FAQAccordion;
